import * as React from 'react'

import { StyledHeader } from './styles'

export enum HeaderVariants {
  HIGH = 'high',
  LOW = 'low',
}

export enum HeaderColorVariants {
  LIGHT = 'light',
  DARK = 'dark',
  BLUE = 'blue',
}

export interface CustomHeaderProps {
  variant?: string
  color?: string
  children?: React.ReactNode
  isFixedWidth?: boolean
  isStaticWidth?: boolean
}

const Header = ({
  variant = HeaderVariants.LOW,
  color = HeaderColorVariants.DARK,
  children,
  isFixedWidth,
  isStaticWidth,
}: CustomHeaderProps) => {
  return (
    <StyledHeader id="nova-shared-Header-root" className={`${variant} ${color}`}>
      <div className={`main ${isFixedWidth ? 'fixedWidth' : ''} ${isStaticWidth ? 'staticWidth' : ''}`}>{children}</div>
    </StyledHeader>
  )
}

export default Header
